import { stateChangeOnlyActionTypeCreator } from '../../store/actionCreators';

export const SET_ENTITY_DIALOG_DATA_SUCCESS_STATUS = stateChangeOnlyActionTypeCreator('entityDialog/success');
export const SET_ENTITY_DIALOG_DATA_LOADING_STATUS = stateChangeOnlyActionTypeCreator('entityDialog/loading');
export const SET_ENTITY_DIALOG_VISIBILiTY_STATUS = stateChangeOnlyActionTypeCreator('entityDialog/visibility');
export const SET_ENTITY_DIALOG_COMPONENT_NAME = stateChangeOnlyActionTypeCreator('entityDialog/component');
export const SET_ENTITY_DIALOG_TITLE = stateChangeOnlyActionTypeCreator('entityDIalog/title');
export const SET_ENTITY_DIALOG_TITLE_APPENDER = stateChangeOnlyActionTypeCreator('entityDIalog/titleAppend');
export const SET_ENTITY_DIALOG_ASK_CONFIRMATION = stateChangeOnlyActionTypeCreator('entityDIalog/askConfirmation');

